import { Component, OnInit } from '@angular/core';
import { Route, Router } from '@angular/router';
import { DynamicMenuService } from './services/dynamic-menu.service';
import { StyleBuilder } from './services/style-builder';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  constructor(
    private router: Router,
    private menu: DynamicMenuService,
    private styleBuilder: StyleBuilder
  ) { }

  title = 'app';

  ngOnInit(): void {
    if (localStorage.getItem('navMenu')) {
      this.menu.setRouteMenu(JSON.parse(localStorage.getItem('navMenu')));
    }
    this.styleBuilder.setLayoutConfig();
  }
}
